// extracted by mini-css-extract-plugin
module.exports = {"costBurden":"styles_costBurden___biHW","vis":"styles_vis__Pq88M","yAxisLabel":"styles_yAxisLabel__1C2yR","legendContainer":"styles_legendContainer__1w538"};